import { Box, Flex } from '@chakra-ui/react';

import { useTrialAiSearchDefaults } from '../../filters/ai-search/useTrialAiSearchDefaults';
import { FilterMenu } from '../../filters/components/FilterMenu';
import {
  FilterTags,
  FilterTagsSupportingAISearch,
} from '../../filters/components/FilterTags';
import { PrimaryFilter } from '../../filters/components/PrimaryFilter';
import { AiSearchProvider } from '../../filters/contexts/AiSearchContext';
import { useTrialScreenerV2Defaults } from '../../filters/hooks/useTrialScreenerV2Defaults';
import { CustomDashActionBar } from '../CustomDashActionBar/CustomDashActionBar';
import { useTabContentConfig } from '../PageConfigProvider/PageConfigProvider';
import { TabManager } from '../TabManager/TabManager';
import { useFilterTags } from './useFilterTags';

export const FilterBar = ({
  FilterTagsComponent,
  hidePrimaryFilterBar = false,
}: {
  FilterTagsComponent?: React.ReactNode;
  hidePrimaryFilterBar?: boolean;
}) => {
  const { config } = useTabContentConfig();
  const { primaryFilter } = config;

  const { filterTags, onRemoveFilter } = useFilterTags();

  return (
    <Box mb="1rem">
      {primaryFilter && !hidePrimaryFilterBar && (
        <Flex alignItems="end">
          <PrimaryFilter primaryFilter={primaryFilter} />
        </Flex>
      )}
      <Flex justifyContent="space-between" paddingTop="1rem">
        <Flex
          justifyContent="flex-start"
          alignItems="flex-start"
          flexDirection="row"
          wrap="wrap"
          columnGap="0.5rem"
          data-testid="non-primary-filter-chips"
        >
          {FilterTagsComponent || (
            <Flex flexWrap="wrap" alignItems="center" gap={2}>
              <FilterTags
                filterTags={filterTags}
                onRemoveFilter={onRemoveFilter}
              />
              <FilterMenu shiftLeft={filterTags.length > 0} />
            </Flex>
          )}
        </Flex>

        <Flex alignItems="center" gap={4}>
          <CustomDashActionBar />
          <TabManager />
        </Flex>
      </Flex>
    </Box>
  );
};

const AiSearchEnabledFilterBarContent = ({
  hidePrimaryFilterBar = false,
}: {
  hidePrimaryFilterBar?: boolean;
}) => {
  useTrialAiSearchDefaults();
  useTrialScreenerV2Defaults();
  const { filterTags, onRemoveFilter } = useFilterTags();
  return (
    <FilterBar
      hidePrimaryFilterBar={hidePrimaryFilterBar}
      FilterTagsComponent={
        <FilterTagsSupportingAISearch
          filterTags={filterTags}
          onRemoveFilter={onRemoveFilter}
        />
      }
    />
  );
};

export const AISearchFilterBar = ({
  hidePrimaryFilterBar = false,
}: {
  hidePrimaryFilterBar?: boolean;
}) => (
  <AiSearchProvider>
    <AiSearchEnabledFilterBarContent
      hidePrimaryFilterBar={hidePrimaryFilterBar}
    />
  </AiSearchProvider>
);

const ScreenerV2FilterBarContent = () => {
  useTrialScreenerV2Defaults();
  return <FilterBar hidePrimaryFilterBar={true} />;
};

export const ScreenerV2FilterBar = () => <ScreenerV2FilterBarContent />;
